import { render, staticRenderFns } from "./cube_4.vue?vue&type=template&id=28a38f48&scoped=true&"
import script from "./cube_4.vue?vue&type=script&lang=js&"
export * from "./cube_4.vue?vue&type=script&lang=js&"
import style0 from "./cube_4.vue?vue&type=style&index=0&id=28a38f48&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a38f48",
  null
  
)

export default component.exports